module.exports = __webpack_public_path__ + "img/img21.0edb7b29.png";